import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { baseUrl } from "../../../../boot";

// Get products
export const getVendorListAll = createAsyncThunk("vendor/getVendorList", async (data, { rejectWithValue }) => {
  const token = localStorage.getItem("authToken");

  try {
    const response = await axios.post(`${baseUrl}vendor/api/v1/getVendorList`, data, {
      headers: {
        "auth-token": token,
        "Content-Type": "application/json",
      },
    });
    return response.data; // ✅ Return only the data
  } catch (error) {
    console.error("Error fetching Vendors", error);

    // ✅ Handle errors properly
    return rejectWithValue(error.response?.data?.message || "Failed to fetch Leads");
  }
});
